/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { isEventUsernameRetrievalAllowed } from '@e180/domain/lib/event/util';

import LoginSupportMainDumb from './LoginSupportMainDumb';
import withFeatureDecisions from 'src/shared/app/feature/component/withFeatureDecisions';
import { getEventPublicData } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  featureDecisions: Object,
};

const mapStateToProps = (state: State, { featureDecisions }: Props): Object => {
  const publicEvent = getEventPublicData(state);

  return {
    isUsernameRetrievalAllowed:
      publicEvent && isEventUsernameRetrievalAllowed(publicEvent),
    isLoginLinkDisabled: featureDecisions.isLoginLinkShownInSupport(),
  };
};

export default compose(
  withFeatureDecisions,
  connect(mapStateToProps),
)(LoginSupportMainDumb);
